<template>
    <div class="container">
        <header>
            <!-- 親コンポーネントのv-slot:headerの要素を受け取る -->
            <slot :name="header"/>
        </header>
        <main class="main">
            <!-- 名前を付けない場合はtemplete外の要素を受け取る -->
            <slot></slot>
        </main>
        <footer>
            <!-- 親コンポーネントのv-slot:footerの要素を受け取る -->
            <slot name="footer"></slot>
        </footer>
    </div>
</template>

<script>
import _ from "lodash"
export default {
    name: 'BaseLayout',
    data() {
        return {
            text: ''
        }
    },
    computed: {
        header() {
            return _.eq(this.text, '/STDSCM01C01') ? 'accountingHeader' : 'businessHeader'
        }
    },
    watch: {
        '$route' (to, from) {
            this.text = to.path
        }
    },
}
</script>

<style scoped>
.container{
    height: 100%;
    display: flex;
    flex-direction: column;
}

.container .main{
    flex-grow: 1;
}
</style>